import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propFunc, propNumber, propShape, } from '../../../../helpers/custom-prop-types';
import SlideOneShow from '../../SlideOne/SlideOneShow';
import SlideOneShowSkeleton from '../../SlideOne/SlideOneShowSkeleton';
const ConsultantSearchListBodySlideOne = (props) => {
    const { onClickCopy, onClickSlideClip, onClickSlideShow, showSlidePage, slideFavoriteMap, slidePageData, } = props;
    const { initialLoaded, list: pages, loading } = slidePageData;
    if (!initialLoaded || (initialLoaded && loading)) {
        return _jsx(SlideOneShowSkeleton, {});
    }
    return (pages.length > 0 && (_jsx(SlideOneShow, { onClickCopy: onClickCopy, onClickShow: onClickSlideShow, onClickSlideClip: onClickSlideClip, pageNo: showSlidePage, pages: pages, slideFavoriteMap: slideFavoriteMap })));
};
ConsultantSearchListBodySlideOne.propTypes = {
    onClickCopy: propFunc().isRequired,
    onClickSlideClip: propFunc().isRequired,
    onClickSlideShow: propFunc().isRequired,
    showSlidePage: propNumber().isRequired,
    slideFavoriteMap: propShape().isRequired,
    slidePageData: propShape().isRequired,
};
export default ConsultantSearchListBodySlideOne;
